import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CommonEntityService } from '../../services/common-entity.service';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-request-translation-button',
  templateUrl: './request-translation-button.component.html',
})
export class RequestTranslationButtonComponent implements OnInit {
  @Input() entityType: string;
  @Input() tableName: string;
  @Input() recordId: number;

  visible = false;
  loading = false;

  constructor(
    private commonEntityService: CommonEntityService,
    private messageService: MessageService,
    public authService: AuthService,
  ) {}

  async ngOnInit(): Promise<void> {
    if (!this.authService.hasPermission(['update'], 'LocalizationController')) {
      return;
    }

    try {
      const response = await this.commonEntityService.existsLocalizationConfig(this.entityType);
      this.visible = response.exists && response.useAiLocalization;
    } catch {
      this.visible = false;
    }
  }

  async requestTranslation(): Promise<void> {
    this.loading = true;
    try {
      await this.commonEntityService.requestTranslation(this.tableName, this.recordId);
      this.messageService.add({
        severity: 'success',
        summary: 'Translation queued',
        detail: 'All localizable fields for this record have been queued for translation.',
        life: 5000,
      });
    } catch (error: any) {
      this.messageService.add({
        severity: 'error',
        summary: 'Translation failed',
        detail: error?.error?.message || 'Failed to request translation. Please try again.',
        life: 5000,
      });
    } finally {
      this.loading = false;
    }
  }
}
